import Breadcrumb from "../components/Breadcrumb";
import DepositeAmountLayer from "../components/child/DepositeAmountLayer";

const DepositeAmount = () => {
  return (
    <>
        {/* Breadcrumb */}
        <Breadcrumb title='Deposit Amount' />

        {/* PropertyLayer */}
        <DepositeAmountLayer />
    </>
  );
};

export default DepositeAmount;
